<template>
  <v-container fluid class="job-posting-detail">
    <v-row class="ma-0">
      <v-col class="pa-0">
        <v-card
          v-if="announcement"
          class="mx-auto px-15 pt-8 pb-13"
          width="960"
          elevation="10"
        >
          <v-row class="ma-0 mb-8" align="center" justify="space-between">
            <v-col cols="auto" class="pa-0 main-title">{{
              announcement.title
            }}</v-col>
            <v-col cols="auto" class="pa-0 term">{{ announcement.term }}</v-col>
          </v-row>
          <v-row class="ma-0">
            <!-- <ckeditor
              :editor="editor"
              :config="editorConfig"
              @ready="editorInit"
              v-model="announcement.content"
            ></ckeditor> -->
            <CommonCkEditor :isReadOnly="true" v-model="announcement.content" />
          </v-row>
          <v-row class="ma-0 mt-8" justify="center">
            <i-btn class="list-btn mr-1" @click="goAnnounceList">{{
              $t('공고목록')
            }}</i-btn>
            <i-btn
              class="support-btn ml-1"
              :class="{ 'is-disabled': !canRegistration }"
              @click="goApply"
            >
              <i class="material-icons-outlined">
                check
              </i>
              {{ $t('지원하기') }}
            </i-btn>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { getJson } from '@/api/network';

// import DecoupledEditor from '@ckeditor/ckeditor5-editor-decoupled/src/decouplededitor';
// import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import moment from 'moment';
import CommonCkEditor from '@/components/common/CommonCkEditor.vue';

export default {
  components: { CommonCkEditor },
  data() {
    return {
      announcement: null,
      // editor: DecoupledEditor,
      // editorConfig: { extraPlugins: [Base64UploadAdapter] },
      canRegistration: true,
    };
  },
  mounted() {
    this.getAnnouncement();
  },
  methods: {
    getAnnouncement() {
      const p = { annoId: this.$route.params.annoId };
      getJson('api/' + this.$route.params.tenantKey + '/announce', p).then(
        res => {
          if (res.status == 200) {
            this.announcement = res.data;
            const term = res.data.term;
            if (term) {
              const parts = term.split('~ ');
              const startStr = parts[0]?.trim().replace(/[^0-9]/g, '');
              const endStr = parts[1]?.trim().replace(/[^0-9]/g, '');
              const now = moment().format('YYYYMMDDHHmm');
              this.canRegistration = startStr <= now && now <= endStr;
            }
          }
        },
      );
    },
    goAnnounceList: function() {
      getJson(
        'api/' + this.$route.params.tenantKey + '/apply/annoList',
        {},
      ).then(res => {
        if (res.status == 200) {
          this.annoListUrl = res.data.annoListUrl;
          window.open(this.annoListUrl, '_blank');
        } else {
          this.$router.push({
            name: 'jobPosting',
            params: { tenantKey: this.$route.params.tenantKey },
          });
        }
      });
    },

    // goNoticePage() {
    //   window.open(this.annoListUrl, '_blank');
    // },
    // goAnnounceList() {
    //   // this.$router.push({
    //   //   name: 'jobPosting',
    //   //   params: { tenantKey: this.$route.params.tenantKey },
    //   // });
    //   window.open(this.annoListUrl, '_blank');
    // },
    goApply() {
      if (!this.canRegistration) {
        this.$showAlert('서류 접수 기간을 확인해 주세요.');
        return;
      }
      if (this.announcement.applyUrl) {
        window.location.href =
          this.announcement.applyUrl +
          '?recruitId=' +
          this.$route.params.annoId;
        return;
      }
      this.$router.push({
        name: 'cv',
        params: {
          annoId: this.$route.params.annoId,
          tenantKey: this.$route.params.tenantKey,
        },
      });
    },
    editorInit(editor) {
      //READ-ONLY
      editor.isReadOnly = true;
      var element = editor.ui.view.toolbar.element;
      element.style.display = 'none';

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(element, editor.ui.getEditableElement());
    },
  },
};
</script>
<style>
.job-posting-detail {
  padding: 32px 0 70px 0;
  background-color: #f2f2f2;
}

.job-posting-detail .main-title {
  font-size: 20px;
  font-weight: 700;
  color: #363c43;
}

.job-posting-detail .turm {
  font-size: 15px;
  font-weight: 500;
  color: #777e87;
}

.job-posting-detail .temporary {
  height: 876px;
  font-size: 50px;
  font-weight: 700;
  line-height: 876px;
  justify-content: center;
  background-color: #d2d2d2;
  color: #363c43;
}

.list-btn {
  height: 38px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: -0.28px !important;
  background-color: #fff !important;
  border: 1px solid #d5d8dc !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  color: #363c43 !important;
}

.support-btn {
  height: 38px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: -0.28px !important;
  background-color: #087ef7 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #fff !important;
}

.support-btn.is-disabled {
  background-color: #b0b8c1 !important;
  cursor: not-allowed !important;
}

.material-icons-outlined {
  font-size: 18px !important;
}
</style>
